import { ModuleWithProviders, NgModule } from '@angular/core';

@NgModule({})
export class AngularHalModule {
    static forRoot(): ModuleWithProviders {
        return ({
            ngModule: AngularHalModule,
        });
    }
}
